import styled from '@emotion/styled';
import { Stack, Text } from '@pairy/pds-react';

export const GrayContainer = styled(Stack)`
  background-color: ${({ theme }) => theme.colors.zinc_50};
  border-radius: 8px;
`;

export const WhiteContainer = styled(Stack)`
  width: 212px;
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
`;

export const Title = styled(Text)`
  white-space: pre-wrap;

  word-break: break-all;
`;

export const ImageContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: 180px;
  height: 102px;
  border: 1px solid ${({ theme }) => theme.colors.zinc_200};
  border-radius: 8px;
`;
